<ng-container *ngIf="permissionsConfig" [formGroup]="permissionsForm">
  <div class="permissions-form" fxLayout="row wrap" >
    <ng-container *ngIf="!disabled">
      <ng-container *ngFor="let permission of permissionsConfig.permissions;">
        <mat-form-field class="permissions-form-field" fxFlex="50">
          <mat-label>{{ permission.displayName }}</mat-label>
          <mat-select [required]="false" [formControlName]="permission.module">
            <mat-option *ngFor="let role of permission.roles" [value]="role">
              {{permissionsConfig.roles[role]}}
            </mat-option>
          </mat-select>
          <button *ngIf="permissionsForm.get(permission.module).value"
                  matSuffix
                  mat-icon-button
                  type="button"
                  aria-label="Clear"
                  (click)="permissionsForm.get(permission.module).setValue(null); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="disabled">
      <ng-container *ngFor="let permission of permissionsConfig.permissions;">
        <div class="permissions-form-field" fxFlex="50">
          <app-detail [header]="permission.displayName" [value]="permissionsConfig.roles[currentPermissions[permission.module]] ?
                      permissionsConfig.roles[currentPermissions[permission.module]] : 'Brak dostępu'"></app-detail>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
